// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Hg","tab":"i_Hh","active":"i_Hi"};